/* Page/DebugBlocked/DebugBlocked.js */
import React from 'react';

const DebugBlocked = () => {
    // Inline CSS styles
    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: '#1a2c4e',
            fontFamily: 'Arial, sans-serif',
            margin: 0,
            padding: '20px',
            boxSizing: 'border-box'
        },
        content: {
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            maxWidth: '500px',
            width: '90%'
        },
        warningIcon: {
            fontSize: '4rem',
            marginBottom: '20px'
        },
        heading: {
            color: '#e74c3c',
            marginBottom: '15px',
            fontSize: '2rem',
            fontWeight: 'bold'
        },
        paragraph: {
            color: '#555',
            marginBottom: '10px',
            fontSize: '1.1rem',
            lineHeight: '1.5'
        },
        debugInfo: {
            background: '#f8f9fa',
            padding: '20px',
            borderRadius: '8px',
            margin: '20px 0',
            textAlign: 'left'
        },
        infoHeading: {
            margin: '0 0 10px 0',
            color: '#333',
            fontSize: '1.1rem'
        },
        list: {
            listStyle: 'none',
            padding: 0,
            margin: '10px 0'
        },
        listItem: {
            padding: '5px 0',
            fontSize: '1rem',
            color: '#555'
        },
        refreshBtn: {
            background: '#1a2c4e',
            color: 'white',
            border: 'none',
            padding: '12px 30px',
            fontSize: '1.1rem',
            borderRadius: '25px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            marginTop: '15px'
        },
        refreshBtnHover: {
            background: '#2980b9',
            transform: 'translateY(-2px)',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)'
        }
    };

    // Handle button hover state
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={styles.warningIcon}>🚫</div>
                <h1 style={styles.heading}>Access Restricted</h1>
                <p style={styles.paragraph}>Developer tools or restricted actions have been detected.</p>
                <p style={styles.paragraph}>Please close all developer tools and refresh the page to continue.</p>

                <div style={styles.debugInfo}>
                    <p style={styles.infoHeading}><strong>Blocked actions:</strong></p>
                    <ul style={styles.list}>
                        <li style={styles.listItem}>❌ Browser Developer Tools</li>
                        <li style={styles.listItem}>❌ Console Access</li>
                        <li style={styles.listItem}>❌ Network Inspection</li>
                        <li style={styles.listItem}>❌ Right-click Context Menu</li>
                        <li style={styles.listItem}>❌ Keyboard Shortcuts (F12, Ctrl+Shift+I, etc.)</li>
                    </ul>
                </div>

                <button
                    style={{
                        ...styles.refreshBtn,
                        ...(isHovered ? styles.refreshBtnHover : {})
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => setIsHovered(false)}
                >
                    Refresh Page
                </button>
            </div>
        </div>
    );
};

export default DebugBlocked;